import React from 'react';
import ServicePage from '../components/services/ServicePage';
import windowGraphics from '../data/services/window-graphics';

const WindowGraphics: React.FC = () => <ServicePage data={windowGraphics} />;

export default WindowGraphics;
